import React from "react";
import SCSMSDashboard from "./SCSMSDashboard";
import type { DashboardPageProps } from "./dashboard.types";

export default function StockDashboard(props: DashboardPageProps) {
  return (
    <SCSMSDashboard
      {...props}
      dashboard="stock"
      title="Stock Dashboard"
      subtitle="Track stock availability, reservations, low-stock risk, movement, adjustments, and aging."
    />
  );
}
